export default __webpack_public_path__ + "static/media/app_logo_pink.50adaa05.svg";